// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 164 ? "f6ef2be3" : chunkId) + "." + {"164":"6becb53dcf4ac1c2","483":"17205a40cf85bbbe","974":"147c114426366e45"}[chunkId] + ".js";
};